import { useState, useRef } from 'react';
import './pageNameAndSearch.css';
import SearchIcon from './searchIcon';

export default function Search() {
  const [showInput, setShowInput] = useState(false);
  const [openBtn, setOpenBtn] = useState('search-btn search-btn-closed');
  const [placeHolder, setPlaceHolder] = useState('place-holder-div');
  const [inputData, setInputData] = useState('');

  const inputRef = useRef();

  const toggleInput = () => {
    setShowInput(!showInput);
    openBtn === 'search-btn search-btn-closed'
      ? setOpenBtn('search-btn')
      : setOpenBtn('search-btn search-btn-closed');

    placeHolder === 'place-holder-div'
      ? setPlaceHolder('')
      : setPlaceHolder('place-holder-div');
    showInput ? inputRef.current.focus() : undefined;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('submited');
  };

  const focusDesktopInput = useRef(null);
  const handleClick = () => {
    focusDesktopInput.current.focus();
  };

  return (
    <>
      <div className='search mobile-search' onSubmit={handleSubmit}>
        <div className={placeHolder}></div>
        {showInput && (
          <input
            ref={inputRef}
            type='text'
            className='mobile-search-box'
            placeholder='Search item'
            value={inputData}
            onChange={(e) => setInputData(e.target.value)}
          />
        )}
        <button className={openBtn} onClick={toggleInput} type='button'>
          <SearchIcon searchIconClassName='mobile-search-icon' />
        </button>
      </div>
      <div className='search desktop-search' onClick={handleClick}>
        <input
          type='text'
          className='desktop-search-box'
          placeholder='Search item'
          value={inputData}
          onChange={(e) => setInputData(e.target.value)}
          ref={focusDesktopInput}
        />
        <SearchIcon
          searchIconClassName='desktop-search-icon'
          onClick={handleClick}
        />
      </div>
    </>
  );
}
